import { render } from "./wzselect.vue?vue&type=template&id=2d47c094&scoped=true"
import script from "./wzselect.vue?vue&type=script&lang=js"
export * from "./wzselect.vue?vue&type=script&lang=js"

import "./wzselect.vue?vue&type=style&index=0&id=2d47c094&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d47c094"]])

export default __exports__